
export default function SuitableFor() {
  const suitable = [
    '29歳以下でゴールドカードを持ちたい方',
    'ドコモ・ahamo・eximoユーザーの方',
    '毎月のスマホ代でポイントを貯めたい方',
    '空港ラウンジを利用したい方',
    'ケータイ補償を重視する方',
    '年間30万円以上カードを利用する方',
  ];

  const notSuitable = [
    '30歳以上の方（申込み不可）',
    'ドコモ以外のキャリアユーザーの方',
    'カード利用額が少ない方（年30万円未満）',
    '年会費無料にこだわる方',
    'dポイントを使う機会が少ない方',
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-[#003366] mb-12">
          dカード GOLD Uが向いている人・向いていない人
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* 向いている人 */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-[#E60033] rounded-full flex items-center justify-center">
                <i className="ri-thumb-up-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#003366]">向いている人</h3>
            </div>
            <ul className="space-y-4">
              {suitable.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-check-line text-[#E60033] text-xl flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* 向いていない人 */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gray-400 rounded-full flex items-center justify-center">
                <i className="ri-thumb-down-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#003366]">向いていない人</h3>
            </div>
            <ul className="space-y-4">
              {notSuitable.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-close-line text-gray-400 text-xl flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
